module.exports = __webpack_public_path__ + "img/mind_skeleton_17.ced7c733.png";